import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CmFormErrorService } from '@ats/cm/core';

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({
    selector: 'form[formGroup]',
    standalone: false
})
export class CmLogFormDirective implements OnInit, OnDestroy {
	@Input('cmFormName')
	name: string = null;

	@Input('cmFormIgnoreLog')
	ignore: boolean = false;

	constructor(
		private fg: FormGroupDirective,
		private route: ActivatedRoute,
		private formErrorService: CmFormErrorService
	) {}

	ngOnInit() {
		if (!this.name) {
			this.name = this.route.snapshot.url.join('/');
		}
		if (!this.ignore) {
			this.formErrorService.registerFormForLogging(this.name, this.fg);
		}
	}

	ngOnDestroy() {
		if (!this.ignore) {
			this.formErrorService.unregisterFormFromLogging(this.name);
		}
	}
}
